import { useEffect, useState } from 'react';
import { Typography } from '../../typography';
import { ModalBase, ModalFooterButtons, ModalWrapper } from '../ModalComponents';
import { YardPlaceScene } from '../../yard-place-scene';
import { i18n } from '../../../i18n';
import { filterBlocksScene } from '../../../utils';
import { Button } from '../../button';

export const yardPlaceSceneModal: any = {};

export const YardPlaceSceneModal = () => {
  const [open, setOpen] = useState(false);
  const [blocksScene, setBlocksScene] = useState('');
  const [initialBlocksScene, setInitialBlocksScene] = useState('');

  const [updateKey, setUpdateKey] = useState(Math.random());

  useEffect(() => {
    yardPlaceSceneModal.open = () => {
      const filteredBlocksScene = filterBlocksScene(
        yardPlaceSceneModal.blocksScene,
        yardPlaceSceneModal.blocks,
      );

      setOpen(true);
      setInitialBlocksScene(filteredBlocksScene);
      setBlocksScene(filteredBlocksScene);
      setUpdateKey(Math.random());
    };
  }, []);

  const handleOnClose = () => {
    Object.keys(yardPlaceSceneModal).forEach((key) => {
      if (key !== 'open') delete yardPlaceSceneModal[key];
    });
    setOpen(false);
  };

  const handleResetClick = () => {
    setInitialBlocksScene('');
    setBlocksScene('');
    setUpdateKey(Math.random());
  };

  const handleSubmitClick = async () => {
    yardPlaceSceneModal.submitClick?.(blocksScene);
    handleOnClose();
  };

  return (
    <ModalBase
      id={'yard-place-scene-modal'}
      paperSize={'full-screen'}
      open={open}
      onClose={handleOnClose}
    >
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.yardPlaceSceneTitle')}
        </Typography>
        <YardPlaceScene
          key={updateKey}
          defaultValue={initialBlocksScene}
          onChange={(value) => setBlocksScene(value)}
          defaultMode="edit-blocks"
        />
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleResetClick}>
            {i18n.t('button.reset')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
